<script>
import DibbleTranslation from "../../../translation/translation";
import DibbleJS from "../../../dibble";
import DibbleApi from "../../../api";
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import DibbleAPI from "../../../api";
import Pagination from "@/commons/pagination/Pagination.vue";

export default {
    name: "MoorageTable",
    display: "Transition",
    components: {Pagination, Datepicker },
    data() {
        return {
            router: this.$router,
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            id: this.$route.params.id,
            boat: null,
            orders: [],
            curentPage: 0,
            totalPage: 0,
            searchingText: "",
            isDateFilter: false,
            startDate: null,
            endDate: null,
            filterStatus: 0,
            selectedSlipName: "",
            slipNameFilter: [],
            status: {
                0: "ALL",
                1: "Done",
                2: "On rent",
                3: "Late",
                4: "Cancelled",
            },
            sorts: {
                SLIP_NO: { id: 1, label: "Boat No." },
                RENTAL_AT: { id: 2, label: "Rented at" },
                RETUNRED_AT: { id: 3, label: "Returned at" },
                RENTER_NAME: { id: 4, label: "Renter name" },
                RENTER_PHONE: { id: 5, label: "Renter phone" },
                ORDER_NO: { id: 6, label: "Order No." },
                STATUS: { id: 7, label: "Status" },
            },
            sortBy: 2,
            isSortAsc: false,
        };
    },

    created() {
        this.getSlipOrderHistory();
    },
    methods: {
        getSlipOrderHistory(page = 0) {
            this.dibbleJs.showLoader();
            const params = {
                request: DibbleApi.api.getMoorageMarinaOrders,
                filter_marina_id: this.$route.params.id,
                page: page,
                search_string: this.searchingText,
                filter_status: this.filterStatus,
                filter_from_date: (this.isDateFilter && this.formatDatetimeOutputForApi(this.startDate)) || "",
                filter_to_date: (this.isDateFilter && this.formatDatetimeOutputForApi(this.endDate)) || "",
                filter_boat_serial: this.selectBoat,
                sort_by: this.sortBy,
                sort_ascending: this.isSortAsc,
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
            this.curentPage = page;
        },
        loadBoatType() {
            const params = {
                request: DibbleAPI.api.adminGetBoatTypeInfo,
                boat_type: this.id
            }
            DibbleJS.callApiRequest(params, this._onLoadBoatTypeSuccess, this._onLoadBoatTypeFailed)
        },

        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                const { orders, num_of_pages } = response
                this.orders = orders || []
                this.totalPage = num_of_pages || 0;
                if (this.orders.length && !this.slipNameFilter.length) {
                    const arr = this.orders.map((order) => order.slip_name);
                    let unique = [...new Set(arr)];
                    this.slipNameFilter = unique;
                }
            }
        },

        onClickPagging(params) {
            this.getSlipOrderHistory(params.pageIndex - 1);
        },

        search() {
            this.curentPage = 0;
            this.getSlipOrderHistory(0);
        },

        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        formatDatetimeOutputForApi(m) {
            return this.$moment(m).format("YYYY-MM-DD") + " 00:00:00";
        },

        onFilterStatus(status) {
            this.curentPage = 0;
            this.filterStatus = status;
        },

        filterByDate(set) {
            this.isDateFilter = set;
            this.getSlipOrderHistory(0);
        },

        filterBySlipName(slipName) {
            this.selectedSlipName = slipName;
            this.getSlipOrderHistory(0);
        },

        onSort(value) {
            if (value.id === this.sortBy) {
                this.isSortAsc = !this.isSortAsc;
            } else {
                this.sortBy = value.id;
                this.isSortAsc = true;
            }
            this.getSlipOrderHistory(this.curentPage);
        },

        formatOrderDateTime(dateStr) {
            return dateStr
                ? this.$moment(dateStr, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY")
                : "";
        },
        _onLoadBoatTypeSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.boat = response
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        },
        _onLoadBoatTypeFailed(error) {
            DibbleJS.hideLoader();
            console.log(error)
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        }
    },
    computed: {
        page() {
            return this.curentPage + 1;
        },
        totalPages() {
            const arr = new Array(this.totalPage);
            return arr;
        },
        boatSerials() {
            const arr = this.orders.map((order) => order.boat_serial);
            let unique = [...new Set(arr)];
            return unique;
        },
    },
    watch: {
        searchingText: _.debounce(function () {
            this.search();
        }, 300),

        filterStatus: function () {
            this.search();
        },
        startDate: function () {
            if (!this.endDate) return;
            this.search();
        },
        endDate: function () {
            if (!this.startDate) return;
            this.search();
        },
    },
};
</script>
<template src="./template/index.html"></template>
<style lang="scss" scoped>
tr.order-row {
    cursor: pointer;
}

tr.order-row:hover {
    background-color: #e1e1e1;
}

.order-history {
    display: flex;
    width: 100%;
    padding: 20px 30px;
    min-width: 1000px;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .table-order {
        flex: 1;
        display: flex;
        flex-direction: column;

        .header-boat-info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-boat {
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: capitalize;
                color: #1C5169;
                font-size: 22px;
            }

            .toggle-button {
                width: 220px;
                background: #dfdfdf;
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                opacity: 0.8;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 30px;
                height: 60px;

                >div {
                    width: calc(100%/3);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-sizing: border-box;

                    &:not(:last-child) {
                        border-right: 1.5px solid #fff;
                    }

                }

                p {
                    font-weight: 600;
                    font-size: 18px;
                    color: #7C7C7A;
                }

                .active-button {
                    p {
                        color: #2C94AB;
                    }

                    background: #D9D9D9 !important;
                    border-top-left-radius: 30px;
                    border-bottom-left-radius: 30px;
                }
            }
        }
    }

    .sidebar-filter {
        width: 20%;
        margin-left: 5%;
        background: #E8EFF1;
        border-radius: 40px;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;

        .header-filter {
            padding: 10px 0px;

            p {
                font-weight: 600;
                font-size: 22px;
                color: #1C5169;
            }
        }

        .line-through {
            height: 1.5px;
            background: #DEE6EA;
            width: calc(100% + 40px);
            margin-left: -20px;
        }

        .boat-no {
            .title {
                font-weight: 700;
                font-size: 16px;
                letter-spacing: 0.04em;
                color: #1C5169;
            }

            .list-no {
                margin-left: -3px;

                button {
                    background: #C2D8DD;
                    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                    border-radius: 20px;
                    border: none;
                    margin: 3px;
                    display: inline-block;
                }

                .active {
                    background: #2C94AB;

                    p {
                        color: #FFFFFF;

                    }
                }

                p {
                    font-weight: 600;
                    font-size: 16px;
                    color: #7C7C7A;
                    padding: 5px 10px;
                    text-align: center;
                }
            }

            .list-select-date {
                display: flex;
                justify-content: space-between;

                .select-date {
                    background: #FFFFFF;
                    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                    border-radius: 20px;
                    padding: 5px 10px;
                    width: 48%;

                    label {
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 10px;
                        color: #7C7C7A;
                        margin: 0;
                    }
                }

                .input-date {
                    border: 0 !important;
                }
            }
        }

        .button-scan-qr {
            display: flex;
            justify-content: flex-end;
            margin: 20px 10px;
            flex: 1;
            flex-direction: column;
            align-items: center;

            button {
                background: #1C5169;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 100px;
                border: none;
                margin-top: 20px;
                width: max-content;
            }

            p {
                font-weight: 600;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                padding: 10px 20px;
            }
        }
    }

}

@media only screen and (max-width: 1250px) {
    .list-select-date {
        display: flex;
        flex-direction: column !important;
    }

    .select-date {
        width: 100% !important;

        &:nth-child(2) {
            margin-top: 10px;
        }
    }

    .button-scan-qr {
        p {
            font-size: 16px !important;
            padding: 10px 10px;
        }
    }

}
</style>
